import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "clientFieldShow",
  components: {
    LoadingAnimation,
  },
  props: {
    clientFieldId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Field...",
      workOrdersSortBy: "name",
      workOrderFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
    };
  },
  created() {
    const jsConn = new JSConn();

    jsConn.formParams = {
      id: this.clientFieldId,
    };

    this.$store.dispatch("needClientField", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
  computed: {
    clientField: function() {
      return this.$store.getters.clientField;
    },
  },
};
